/**
 * ProtectedRoute Component
 *
 * Wrapper that protects routes requiring authentication.
 * Redirects to sign-in if not authenticated.
 */

import { useAuth } from '@/lib/auth';
import { Navigate, useLocation } from '@tanstack/react-router';
import type { ReactNode } from 'react';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/sign-in"
        search={{ redirect: location.pathname }}
        replace
      />
    );
  }

  return <>{children}</>;
}
